export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">关于我们</h2>
        </div>

        <div className="max-w-[800px]">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            911吃瓜网是一个专注于娱乐八卦与热点事件追踪的内容平台。我们致力于为读者提供最新热点、今天吃瓜、今日八卦等第一手热门爆料汇总。自成立以来，平台始终坚持快速、准确、全面的内容理念，覆盖明星恋情、综艺争议、网红动态、社会热议等数十个话题领域，每日吃瓜实时更新，已成为数百万吃瓜群众获取资讯的首选入口。我们的编辑团队由资深媒体人与热心读者共同组成，每一篇内容都经过精心整理与多方验证，确保你在911吃瓜网上看到的每一条爆料都经得起推敲。
          </p>
          <div className="flex flex-wrap gap-4 mt-6">
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-50 border border-primary-100">
              <i className="ri-eye-line text-primary-600"></i>
              <span className="text-sm text-primary-700 font-medium">日均访问 50万+</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-50 border border-accent-100">
              <i className="ri-file-list-3-line text-accent-600"></i>
              <span className="text-sm text-accent-700 font-medium">累计爆料 10万+</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-50 border border-secondary-100">
              <i className="ri-user-star-line text-secondary-600"></i>
              <span className="text-sm text-secondary-700 font-medium">活跃读者 30万+</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}